import { useAuth0 } from "@equipmentshare/auth0-react"
import { FlagProvider } from "@equipmentshare/feature-flags"
import { LAUNCH_DARKLY_CLIENT_ID } from "@app/services/env"

export type FeatureFlagProviderProps = {
	children: React.ReactNode
}

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({ children }) => {
	const { isLoading: loadingAuth } = useAuth0()

	if (loadingAuth) {
		return <>{children}</>
	}

	return (
		<FlagProvider
			clientId={LAUNCH_DARKLY_CLIENT_ID}
			flags={{
				EnableBulkLabelGeneratorLastCreated: false,
			}}
			options={
				{
					// TODO: Add below when datadog rum is enabled
					// inspectors: [
					//     {
					//         type: "flag-used",
					//         name: "dd-inspector",
					//         method: (key, detail) => {
					//             datadogRum.addFeatureFlagEvaluation(key, detail.value)
					//         },
					//     },
					// ],
				}
			}
		>
			{children}
		</FlagProvider>
	)
}
